import { EMPTY_VALUE_PLACEHOLDER } from '@/experiences/sales-portal/domain/prospects/screens/prospects/constants';
import { formatCurrency } from '@/utils/money';

export const formatWeeklyValue = (
  valueInMicros: number | null | undefined,
  currencyCode: string,
): string =>
  valueInMicros === null || valueInMicros === undefined
    ? EMPTY_VALUE_PLACEHOLDER
    : formatCurrency(valueInMicros, currencyCode, { maximumFractionDigits: 0 });

export const formatCompactValue = (
  valueInMicros: number | null | undefined,
  currencyCode: string,
): string =>
  valueInMicros === null || valueInMicros === undefined
    ? EMPTY_VALUE_PLACEHOLDER
    : formatCurrency(valueInMicros, currencyCode, {
        maximumFractionDigits: 1,
        minimumFractionDigits: 0,
        notation: 'compact',
      });
